<div [ngClass]="{ 'nav-item': inNavbar }" ngbDropdown>
  <button *ngIf="inNavbar; else button" role="button" id="language-dropdown" class="nav-link" ngbDropdownToggle>
    {{ currentLanguage | translate }}<i class="icon-down-open-big"></i>
  </button>
  <ng-template #button>
    <button id="language-dropdown" href="javascript:void(0)" ngbDropdownToggle>
      {{ currentLanguage }}
    </button>
  </ng-template>
  <div
    ngbDropdownMenu
    aria-labelledby="language-dropdown"
    id="languageDropdown"
    [ngClass]="menuClass"
    class="menuClass"
  >
    <button
      class="dropdown-item"
      type="button"
      *ngFor="let language of displayLanguages"
      (click)="setLanguage(language.code)"
      [ngClass]="language.code"
    >
      {{ language.displayName }}
    </button>
  </div>
</div>
